import React from 'react';
import { ModalStateProps } from '../base/Modal';

export type ModalTrigger = (open: () => any) => React.ReactNode;

export interface ModalControllerProps {
  trigger: ModalTrigger;
  children: (args: ModalStateProps) => React.ReactNode;
}

export const ModalController = (props: ModalControllerProps) => {
  const { trigger, children } = props;
  const [show, setShow] = React.useState(false);

  return (
    <React.Fragment>
      {trigger(() => setShow(true))}
      {children({ show: show, onHide: () => setShow(false) })}
    </React.Fragment>
  );
};
